<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Histórico do paciente {{historico.data[0] ? historico.data[0].nm_paciente : ''}}</b>
						</h3>
					</div>
					<div class="box-body">
						<table class="table table-bordered table-striped">
							<thead>
								<tr>
									<th>Situação</th>
									<th>Unidade realizadora</th>
									<th>Data da realização</th>
									<th>Prof. Realizador</th>
									<th>Procedimento</th>
									<th>Solicitado em</th>
									<th>Unidade solicitante</th>
									<th>Prof. Solicitante</th>
									<th>Prof. Marcador</th>
								</tr>
							</thead>
							<tbody>
								<tr class="even" role="row" v-for="(item, index) in historico.data" :key="index">
									<td>{{item.st_solicitacao | situacaoSolicitacaoAntiga}}</td>
									<td>{{ item.nm_unidade_realizadora }}</td>
									<td>{{ item.dt_realizacao | dataFormatada }}</td>
									<td>{{ item.nm_profissional_realizador }}</td>
									<td>{{ item.nm_procedimento }}</td>
									<td>{{ item.dt_solicitacao | dataFormatada }}</td>
									<td>{{ item.nm_unidade_solicitante }}</td>
									<td>{{ item.nm_profissional_solicitante}}</td>
									<td>{{ item.nm_profissional_marcador}}</td>
								</tr>
							</tbody>
						</table>
						<br>
						<div class="row">
							<div class='col-sm-5'>
								Mostrando {{ this.historico.from }} até {{ this.historico.to }} de {{ this.historico.total }} registros encontrados.
							</div>
							<div class='col-sm-7' style="text-align:right">
								<laravue-pagination :limit="7" :data="historico" v-on:pagination-change-page="getHistorico">
									<span slot="prev-nav">&lt; Anterior</span>
									<span slot="next-nav">Próximo &gt;</span>
								</laravue-pagination>
							</div>
						</div>
						<br>
						<div class="row">
							<div class="col-md-12">
								<button v-if="this.hasPermission('paciente-integracao.write')" :disabled="disableBtnImportar" @click="showModalImportarHistorico = true" class="btn btn-primary pull-right"><span class="fa fa-arrow-down"></span> Importar histórico</button>
								<router-link tag="a" :to="'/integracao/pacientes'" class="btn btn-default"><span class="fa fa-reply"></span> Voltar</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal-importar-historico :cdPessoa="$route.params.cdPessoa" :show="showModalImportarHistorico" @close="showModalImportarHistorico = false" @historicoImportado="historicoImportado()"></modal-importar-historico>
	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	import modalImportarHistorico from '@/components/integracao/pacientes/modalImportarHistorico';

	export default {
		data: () => ({
			historico: {
				data: []
			},
			showModalImportarHistorico: false,
			disableBtnImportar: true
		}),
		mounted() {
			this.getHistorico()
			this.checarImportacao()
		},
		methods: {
			getHistorico(page) {
				if (typeof page === 'undefined') {
					page = 1;
				}

				let config = this.$store.getters.getHeaderAuth;
				config.params = {
					page: page,
					cd_pessoa: this.$route.params.cdPessoa
				};

				axios.get(`${this.$store.state.serverURI}/api/integracao/pacientes/historico`, config)
					.then(response => {
						this.historico = response.data;
					}).catch((error) => {
						console.log(error);
					});
			},
			historicoImportado() {
				this.checarImportacao();
				this.showModalImportarHistorico = false;
			},
			checarImportacao() {
				axios.get(`${this.$store.state.serverURI}/api/integracao-historico/checarImportacao/` + this.$route.params.cdPessoa, this.$store.getters.getHeaderAuth)
					.then(response => {
						if (response.data.status) {
							this.disableBtnImportar = true;
						} else {
							this.disableBtnImportar = false;
						}
					}).catch((error) => {
						console.log(error);
					});
			},
			situacao(item) {
				switch (item.st_solicitacao) {
					case 1:
						return 'EM ANALISE';
					case 2:
						return 'APROVADA';
					case 3:
						return 'CONFIRMADA';
					case 4:
						return 'NEGADA';
					case 5:
						return 'EM PERÍCIA';
					case 6:
						return 'CANCELADA';
					case 7:
						return 'REALIZADA';
					case 8:
						return 'FALTA';
					case 9:
						return 'EM SUPERVISÃO';
					case 10:
						return 'SUPERVISIONADO';
					case 11:
						return 'EM EXTRAPOLACAO';
					case 12:
						return 'TFD';
					case 18:
						return 'FALTA AUTOMÁTICA';
				}
			}
		},
		watch: {

		},
		components: {
			modalImportarHistorico
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// historico.vue?1d67aede